
import { useToastContext } from "components/alert/ToastContext";
import ModalComentarioAuditoria from "components/modal/auditoria/ModalComentarioAuditoria";
import saveAs from 'file-saver';
import Auditoria from "model/auditoria5s/auditoria/Auditoria";
import ClasseAuditoria from "model/auditoria5s/auditoria/ClasseAuditoria";
import ItemClasseAuditoria from "model/auditoria5s/auditoria/ItemClasseAuditoria";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import AuditoriaService from "service/auditoria5s/AuditoriaService";
import { converterData } from "utils/convert";

const auditoriaService = new AuditoriaService();
export function AuditoriaPublicPage() {
    const [queryParameters] = useSearchParams();

    const { startLoading, stopLoading } = useLoadingContext();

    const { msgErro } = useToastContext();

    const titulo = "Auditoria";
    const [auditoria, setAuditoria] = useState<Auditoria>(new Auditoria());
    const [classeSelecionada, setClasseSelecionada] = useState<ClasseAuditoria | null>(null);
    const [itemSelecionado, setItemSelecionado] = useState<ItemClasseAuditoria | null>(null);

    

    const [visibleModalImage, setVisibleModalImage] = useState(false);

    useEffect(() => {
        auditoriaService.consultarPublic(queryParameters.get('id') || '0').then((data) => {
            setAuditoria(data);
        }).catch(error => {
            console.log(error);
        })

    }, [])


    const gerarRelatorio = () => {
        startLoading();
        auditoriaService.getRelatorioPublic(queryParameters.get('id') || '0').then(data => {
            const file = new Blob([data], { type: 'application/pdf' });
            saveAs(file, `Auditoria ${auditoria?.setor?.nome} - ${auditoria.mes} - ${auditoria.ano}.pdf`);
            stopLoading();
        }).catch(err => {
            stopLoading();
            msgErro("Erro ao gerar Relatório", err.message);
            console.log(err);
        });
    }

    return (
        <div className="container">
            {visibleModalImage ? <ModalComentarioAuditoria style={{ width: '95vw' }}
                visible={visibleModalImage} setVisible={(e) => setVisibleModalImage(e)} item={itemSelecionado}
            /> : null}

            {
                titulo ?
                    <div className="row">
                        <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                    </div>
                    : null
            }

            <div className="row">
                <label className="col col-sm-12">Nome</label>
                <div className="col-sm-12">
                    <InputText value={auditoria.nome} readOnly onChange={(e) => setAuditoria({ ...auditoria, nome: e.target.value })} style={{ width: '100%' }} />
                </div>
            </div>
            <div className="row">
                <label className="col col-sm-12">Setor</label>
                <div className="col-sm-12">
                    <InputText value={auditoria.setor?.nome} readOnly style={{ width: '100%' }} />
                </div>

            </div>
            <div className="row">
                <label className="col col-sm-12">Mês</label>
                <div className="col-sm-12">
                    <InputText value={auditoria.mes?.toString()} readOnly style={{ width: '75px', marginRight: 10 }} />
                    <InputText value={auditoria.ano?.toString()} readOnly style={{ width: '150px' }} />
                </div>
            </div>

            <div className="row">
                <label className="col col-sm-12">Data Início</label>
                <div className="col-sm-12">
                    <InputText value={converterData(auditoria.dataInicio)} readOnly style={{ width: '100%' }} />
                </div>
            </div>
            <div className="row">
                <label className="col col-sm-12">Data Fim</label>
                <div className="col-sm-12">
                    <InputText value={converterData(auditoria.dataFim)} readOnly style={{ width: '100%' }} />
                </div>
            </div>
            <div className="row">
                <label className="col col-sm-12">Responsavel</label>
                <div className="col-sm-12">
                    <InputText value={auditoria.usuario?.nome} readOnly style={{ width: '100%' }} />
                </div>
            </div>
            <div className="row">
                <label className="col col-sm-12">Status</label>
                <div className="col-sm-12">
                    <InputText value={auditoriaService.getStatusAuditoria(auditoria.status)} readOnly style={{ width: '100%' }} />
                </div>
            </div>
            {
                auditoria.status === "CANCELADA" ? <div className="row">
                    <label className="col col-sm-12">Observação de cancelamento</label>
                    <div className="col-sm-12">
                        <InputTextarea value={auditoria.observacaoCancelamento} style={{ width: "100%" }} readOnly />
                    </div>
                </div> : null
            }
            <div className="row">
                <label className="col col-sm-12">Nota final</label>
                <div className="col-sm-12">
                    <InputText value={auditoria.notaFinal != null ? auditoria.notaFinal.toString() : ""} readOnly style={{ width: '100%' }} />
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12" style={{ width: "100%", marginTop: 20 }}>
                    <DataTable
                        header="Classes"
                        emptyMessage="Nenhuma classe encontrada"
                        value={auditoria.classesAuditoria}
                        selectionMode="single"
                        selection={classeSelecionada!}
                        onSelectionChange={(e) => {
                            setItemSelecionado(null);
                            setClasseSelecionada(e.value as ClasseAuditoria)
                        }}
                    >
                        <Column field="nome" header="Nome" />
                        <Column field="notaMaxima" header="Nota máxima" />
                        <Column field="notaFinal" header="Nota" />

                    </DataTable>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12" style={{ width: "100%", marginTop: 20 }}>
                    <DataTable
                        header="Itens"
                        emptyMessage="Nenhum item encontrado"
                        value={classeSelecionada?.itensAuditoria ? classeSelecionada.itensAuditoria : []}
                        scrollable={true}
                        scrollHeight="400px"
                        onRowDoubleClick={(e) => { setVisibleModalImage(true) }}
                    >
                        <Column field="nome" header="Nome" />
                        <Column field="resultado" body={(rowData) => auditoriaService.getResultadoItemAuditoria(rowData.resultado)} header="Resultado" />
                        <Column field="status" body={(rowData) => auditoriaService.getStatusItemAuditoria(rowData.status)} header="Status" />
                        <Column style={{ textAlign: "center" }} header={<i className="pi pi-comment" ></i>} body={(rowData: ItemClasseAuditoria) => {
                            return rowData.comentariosAuditoria && rowData.comentariosAuditoria.length > 0 ?
                                <Button icon="pi pi-comment" className="p-button-rounded" onClick={(e) => {
                                    setItemSelecionado(rowData);
                                    setVisibleModalImage(true);
                                }} /> : null
                        }} />

                    </DataTable>
                </div>
            </div>
            <Button label="Gerar Relatório" icon="pi pi-file-pdf" className="p-button-raised p-button-info" onClick={gerarRelatorio} style={{ marginTop: 10, float: "right" }} />
        </div>
    );
}